import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthGuardService } from '../guard/auth-guard/auth-guard.service';
@Injectable({
  providedIn: 'root'
})
export class GraphapiService {
  getManagerDatailsURL = 'https://graph.microsoft.com/v1.0/me/manager';
  getProfilePhotoURL = 'https://graph.microsoft.com/v1.0/me/photo/$value';
  profilePhotoObj: any;
  imageNotFound: boolean = true;

  constructor(public http: HttpClient, private readonly authSrv: AuthGuardService) { }
  getProfilePhoto() {
    return this.profilePhotoObj;
  }
  setProfilePhoto(response:any) {
    this.profilePhotoObj = response;
  }
  setImageNotFound(value: any) {
    this.imageNotFound = value;
  }

  getImageNotFound() {
    return this.imageNotFound;
  }

  // Builds headers with the current in-memory access token on every call - previously this
  // was a module-level const evaluated once at import time (before login could populate it,
  // and now impossible anyway since a service can only be injected into a class, not
  // top-level module code).
  private getAuthHeaders(contentType: string): HttpHeaders {
    // Falls back to '' so a null/not-yet-populated access token can't throw inside
    // HttpHeaders' internal value.toString() call.
    const token: any = this.authSrv.getAccessToken() ?? '';
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (isIEOrEdge) {
      return new HttpHeaders({
        'Content-Type': contentType,
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Authorization': token
      });
    }
    return new HttpHeaders({
      'Content-Type': contentType,
      'Authorization': token
    });
  }

  async getManagerDatails() {
    const httpOptions = { headers: this.getAuthHeaders('application/x-www-form-urlencoded; charset=UTF-8') };
    return this.http.get(this.getManagerDatailsURL, { ...httpOptions }).pipe((data: any) => {
      return data;
    })
  }

  async getProfilePhotoFn() {
    const options: any = { headers: this.getAuthHeaders('image/jpg') };
    return this.http.get(this.getProfilePhotoURL, { ...options, responseType: 'blob' }).pipe((data: any) => {
      return data;
    })
  }
}
